import angular from "angular";
import toaster from "./toaster.directive";

export default angular.module("toaster", []).directive("toaster", toaster);

